import * as React from 'react';
import { useForm } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Backdrop, CircularProgress } from '@mui/material';
import clsx from 'clsx';

import { InquiryBookingSummary } from './InquiryBookingSummary';
import styles from './InquiryForm.module.css';
import { InquirySummary } from './InquirySummary';

type Props = {
  onBackClick: () => void;
};

export const InquiryConfirm = ({ onBackClick }: Props) => {
  const { t } = useTranslation();

  React.useEffect(() => window.scrollTo(0, 0));

  const form = useForm();

  const { submitting } = form.getState();

  return (
    <div className={styles['post-main__frame']}>
      <Backdrop open={submitting} style={{ zIndex: 1 }}>
        <CircularProgress />
      </Backdrop>
      <p className={styles['post-main__ttl']}>{t('Confirm Inquiry Info')}</p>

      <InquiryBookingSummary />

      <InquirySummary />

      <div className={styles['post-main__btns']}>
        <a className={styles['bg-color-sub']} onClick={onBackClick}>
          {t('Edit')}
        </a>
        <button
          disabled={submitting}
          className={clsx(
            styles['bg-color-main'],
            styles['post-main__btn'],
            submitting && styles['loading']
          )}
          type="submit"
        >
          {t('Submit')}
        </button>
      </div>
    </div>
  );
};
